import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResult } from '../models/ApiResult';
import { Observable } from 'rxjs';
import { ValidacionResult } from '../models/ValidacionResult';
import { RelacionResult } from '../models/RelacionesResult';
import { TestigoMapa } from '../models/testigomapa';

@Injectable()
export class ValidacionService {
  myAppUrl: string;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getExpedienteID(ID: number) {
    return this.http.get(this.myAppUrl + 'api/Valoracion/' + ID);
  }

  getTestigos(ID: number) {
    return this.http.get<TestigoMapa[]>(this.myAppUrl + 'api/INMRelTasTestigo/GetTestigos/' + ID);
  }

  getTestigosOtros(ID: number){
    return this.http.get<TestigoMapa[]>(this.myAppUrl + 'api/INMRelTasTestigo/GetTestigosAll/' + ID)
  }

  getTasaciones(ID: number) {
    return this.http.get(this.myAppUrl + 'api/INMRelTasTestigo/GetOtrasTasaciones/' + ID)
  }

  deleteRel(ID: number): Observable<ApiResult> {
    return this.http.delete<ApiResult>(this.myAppUrl + 'api/INMRelTasTestigo/' + ID);
  }

  postTestigos(testigo: object): Observable<ApiResult> {
    return this.http.post<ApiResult>(this.myAppUrl + 'api/INMTestigos/GetByID/', testigo);
  }

  gestEstado(tasacionID: string): Observable<ValidacionResult> {
    return this.http.get<ValidacionResult>(this.myAppUrl + 'api/Valoracion/Estado/' + tasacionID);
  }

  tieneTestigos(tasacionID: string): Observable<number> {
    return this.http.get<number>(this.myAppUrl + 'api/INMTestigos/TieneTestigos/' + tasacionID);
  }
}
